module.exports = __webpack_public_path__ + "static/scale-model-of-allen-centennial-garden-in-madison-wisconsin-9e9a7cd84d964406027aefc889480039.png";